import React, { useState, useEffect } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { getAppId, getEmail, getApplicantBirthDate, setTStageID, setAddressInfo, set1BpersonalInfo, getParentInfo, getStageID } from "../utility/Common";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import NavBar_appID from "./layout/NavBar_appID";
import { createNotification } from "./Popup";
import { applicationManagementMasilingi } from "../utility/services/apiService";
import { getResource } from "../utility/services/resources";
import { messages } from "../utility/services/message";

import DatePicker from "react-date-picker";
import "../includes/css/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import CentryReusableComponent from "./CentryReusableComponent";

function Step_three() {
  let navigate = useNavigate();
  console.log(getApplicantBirthDate());

  const ApplicantDoB = getApplicantBirthDate();
  let childBirthYear = null;
  if (ApplicantDoB) {
    const dateParts = ApplicantDoB.split(" ");
    if (dateParts.length >= 4) {
      childBirthYear = parseInt(dateParts[3]);
    } else {
      console.error("Unexpected date format:", ApplicantDoB);
    }
  } else {
    console.error("ApplicantDoB is null or undefined");
  }

  const parentsInfoData = useLocation();
  // var Stage = parentsInfoData.state?.DocStageID;
  var Stage = +getStageID()
  //===================== father states ==========================
  const [selectedCountries, setSelectedCountries] = useState("");
  const [BirthWardID, setBirthWardID] = useState("");
  const [BirthVillage, setBirthVillage] = useState("");
  const [FatherFullName, setFatherFullName] = useState("");
  const [FatherDOB, setFatherDOB] = useState("");
  const [FatherCountries, setFatherCountries] = useState([]);
  const [FatherRegions, setFatherRegions] = useState([]);
  const [FatherDistrictID, setFatherDistrictID] = useState("");
  const [FatherDistricts, setFatherDistricts] = useState([]);
  const [FatherWards, setFatherWards] = useState([]);
  const [FatherVillage, setFatherVillage] = useState("");
  const [stageID, setStageID] = useState(null);
  const [FatherCountryID, setFatherCountryID] = useState();
  const [FatherTerritories, setFatherTerritories] = useState([]);
  const [fatherTerritoryID, setFatherTerritoryID] = useState();
  const [fatherRegionID, setFatherRegionID] = useState();
  const [FatherWardID, setFatherWardID] = useState();
  const { checkApplicationStage } = CentryReusableComponent({});
  //====================== mother states =======================
  const [MotherFullName, setMotherFullName] = useState("");
  const [MotherDOB, setMotherDOB] = useState("");
  const [MotherVillage, setMotherVillage] = useState("");
  const [MotherCountries, setMotherCountries] = useState([]);
  const [motherCountryID, setMotherCountryID] = useState();
  const [MotherTerritories, setMotherTerritories] = useState([]);
  const [motherTerritoryID, setMotherTerritoryID] = useState();
  const [MotherRegions, setMotherRegions] = useState([]);
  const [motherRegionID, setMotherRegionID] = useState();
  const [MotherWards, setMotherWards] = useState([]);
  const [motherWardID, setMotherWardID] = useState();
  const [MotherDistricts, setMotherDistricts] = useState([]);
  const [MotherDistrictID, setMotherDistrictID] = useState("");

  //======Lookups
  useEffect(() => {
    fetchFatherCountries();
    fetchMotherCountries();
    setParentsInfo();
  }, []);

  const setParentsInfo = () => {
    checkApplicationStage(2)
    // const data = parentsInfoData?.state;
    const data = getParentInfo()
    setStageID(data?.DocStageID);
    setSelectedCountries(parentsInfoData?.ResidenceCountryID);

    //=================== Set Father information ===========================
    setFatherFullName(data?.FatherFullName);
    setFatherDOB(data?.FatherDOB);
    setFatherVillage(data?.FatherVillage);
    setFatherCountryID(data?.FatherCountryID);
    setFatherTerritoryID(data?.FatherTerritoryID);
    if (data?.FatherCountryID) {
      fetchFatherTerritory(data?.FatherCountryID);
    }
    setFatherRegionID(data?.FatherRegionalId);
    if (data?.FatherTerritoryID) {
      fetchFatherRegions(data?.FatherTerritoryID);
    }
    setFatherDistrictID(data?.FatherDistrictID);
    if (data?.FatherRegionalId) {
      fetchFatherDistricts(data?.FatherRegionalId);
    }
    setFatherWardID(data?.FatherWard);
    if (data?.FatherDistrictID) {
      fetFatherWards(data?.FatherDistrictID);
    }

    //=================== Set Mother information ===========================
    setMotherFullName(data?.MotherFullName);
    setMotherDOB(data?.MotherDOB);
    setMotherVillage(data?.MotherVillage);
    setMotherCountryID(data?.MotherCountryID);

    setMotherTerritoryID(data?.MotherTerritoryID);
    if (data?.MotherCountryID) {
      fetchMotherTerritory(data?.MotherCountryID);
    }
    setMotherRegionID(data?.MotherRegionalId);
    if (data?.MotherTerritoryID) {
      fetchMotherRegions(data?.MotherTerritoryID);
    }
    setMotherDistrictID(data?.MotherDistrictID);
    if (data?.FatherRegionalId) {
      fetchMotherDistricts(data?.MotherRegionalId);
    }
    setMotherWardID(data?.MotherWard);
    if (data?.MotherDistrictID) {
      fetMotherWards(data?.MotherDistrictID);
    }
  };

  //======fetchFatherCountries
  const fetchFatherCountries = async () => {
    const result = await getResource("Country", "null", "null", "lookup");
    if (Array.isArray(result) && result.length > 0) {
      setFatherCountries(result);
    } else {
      setFatherCountries([]);
    }
  };

  //======selectCountry
  const getFatherCountryIDChange = (e) => {
    const countryID = e.target.value;
    setFatherCountryID(countryID);
    setFatherWardID(countryID);
    fetchFatherTerritory(countryID);
  };
  const fetchFatherTerritory = async (territoryId) => {
    const result = await getResource(
      "TerritoryByCountry",
      territoryId,
      "null",
      "lookup"
    );
    if (Array.isArray(result) && result.length > 0) {
      setFatherTerritories(result);
    } else {
      setFatherTerritories([]);
    }
  };

  //====== selectTerritory ==================
  const getFatherTerritoryIDChange = (e) => {
    const territoryID = e.target.value;
    setFatherTerritoryID(territoryID);
    fetchFatherRegions(territoryID, FatherCountryID);
  };

  const fetchFatherRegions = async (territoryID, fatherCountryID) => {
    const result = await getResource(
      "RegionBirth",
      territoryID,
      fatherCountryID,
      "lookup"
    );
    if (Array.isArray(result) && result.length > 0) {
      setFatherRegions(result);
    } else {
      setFatherRegions([]);
    }
  };

  //======  selectRegion ===================
  const getFatherRegionIDChange = (e) => {
    const regionID = e.target.value;
    setFatherRegionID(regionID);
    fetchFatherDistricts(regionID);
  };
  const fetchFatherDistricts = async (regionID) => {
    const result = await getResource(
      "DistrictByRegionID",
      regionID,
      "null",
      "lookup"
    );
    if (Array.isArray(result) && result.length > 0) {
      setFatherDistricts(result);
    } else {
      setFatherDistricts([]);
    }
  };

  //====== selectDistrict ====================
  const getFatherDistrictIDChange = (e) => {
    const districtID = e.target.value;
    setFatherDistrictID(districtID);
    fetFatherWards(districtID);
  };

  const fetFatherWards = async (districtId) => {
    const result = await getResource(
      "WardByDistrict",
      districtId,
      "null",
      "lookup"
    );
    if (Array.isArray(result) && result.length > 0) {
      setFatherWards(result);
    } else {
      setFatherWards([]);
    }
  };

  //======selectWard
  const getFatherBirthWardIDChange = (e) => {
    const BirthWardID = e.target.value;
    setFatherWardID(BirthWardID);
  };

  //======fetchMotherCountries
  const fetchMotherCountries = async () => {
    const result = await getResource("Country", "null", "null", "lookup");
    if (Array.isArray(result) && result.length > 0) {
      setMotherCountries(result);
    } else {
      setMotherCountries([]);
    }
  };

  //===========  selectCountry ============
  const getMotherCountryIDChange = (e) => {
    const countryID = e.target.value;
    setMotherCountryID(countryID);
    setMotherWardID(countryID);
    fetchMotherTerritory(countryID);
  };
  const fetchMotherTerritory = async (territoryId) => {
    const result = await getResource(
      "TerritoryByCountry",
      territoryId,
      "null",
      "lookup"
    );
    if (Array.isArray(result) && result.length > 0) {
      setMotherTerritories(result);
    } else {
      setMotherTerritories([]);
    }
  };

  //======selectTerritory
  const getMotherTerritoryIDChange = (e) => {
    const territoryID = e.target.value;
    setMotherTerritoryID(territoryID);
    fetchMotherRegions(territoryID, motherCountryID);
  };
  const fetchMotherRegions = async (territoryID, motherCountry) => {
    const result = await getResource(
      "RegionBirth",
      territoryID,
      motherCountry,
      "lookup"
    );
    if (Array.isArray(result) && result.length > 0) {
      setMotherRegions(result);
    } else {
      setMotherRegions([]);
    }
  };

  //======selectRegion
  const getMotherRegionIDChange = (e) => {
    const regionID = e.target.value;
    setMotherRegionID(regionID);
    fetchMotherDistricts(regionID);
  };
  const fetchMotherDistricts = async (regionID) => {
    const result = await getResource(
      "DistrictByRegionID",
      regionID,
      "null",
      "lookup"
    );
    if (Array.isArray(result) && result.length > 0) {
      setMotherDistricts(result);
    } else {
      setMotherDistricts([]);
    }
  };

  //======selectDistrict
  const getMotherDistrictIDChange = (e) => {
    const districtID = e.target.value;
    setMotherDistrictID(districtID);
    fetMotherWards(districtID);
  };
  const fetMotherWards = async (districtId) => {
    const result = await getResource(
      "WardByDistrict",
      districtId,
      "null",
      "lookup"
    );
    if (Array.isArray(result) && result.length > 0) {
      setMotherWards(result);
    } else {
      setMotherWards([]);
    }
  };

  //======selectWard
  const getMotherBirthWardIDChange = (e) => {
    const BirthWardID = e.target.value;
    setMotherWardID(BirthWardID);
  };

  const fixTimezoneOffset = (date) => {
    if (!date) return null;
    const userTimezoneOffset = date.getTimezoneOffset() * 60000;
    return new Date(date.getTime() - userTimezoneOffset);
  };

  // const validateParentDOB = (dob, setParentDOB, role) => {
  //   if (!dob) return;

  //   const parentBirthDate = fixTimezoneOffset(new Date(dob));
  //   if (isNaN(parentBirthDate.getTime())) {
  //     createNotification({
  //       type: "error",
  //       message: `Tafadhali weka tarehe sahihi kwa ajili ya ${role}.`,
  //     })();
  //     return;
  //   }

  //   const parentBirthYear = parentBirthDate.getFullYear();
  //   const childBirthYear = new Date(getApplicantBirthDate()).getFullYear();
  //   const minParentYear = childBirthYear - 14;

  //   if (parentBirthYear > minParentYear) {
  //     createNotification({
  //       type: "error",
  //       message: `Mwaka wa kuzaliwa kwa ${role} lazima uwe angalau miaka 14 kabla ya mwaka wa kuzaliwa kwa mtoto`,
  //     })();
  //     setParentDOB(null);
  //   } else {
  //     setParentDOB(parentBirthDate);
  //   }
  // };



//======================= New code for date validation =========================

  //The age logic is okay, 
  // but the risky part is timezone handling because parent date uses fixTimezoneOffset()
  //  while child date does not. 
  // This can lead to incorrect age validation if the user's timezone
  //  causes the parent date to shift to a different day.
  //Here the New code for date validation that normalizes both parent and child dates to
  //  remove time component and fix timezone offset before comparison.

const validateParentDOB = (dob, setParentDOB, role) => {
  if (!dob) return;

  const normalizeDate = (date) =>
    new Date(date.getFullYear(), date.getMonth(), date.getDate());

  const parentBirthDateRaw = new Date(dob);

  if (isNaN(parentBirthDateRaw.getTime())) {
    createNotification({
      type: "error",
      message: `Tafadhali weka tarehe sahihi kwa ajili ya ${role}.`,
    })();
    return;
  }

  const childBirthDateRaw = new Date(getApplicantBirthDate());

  if (isNaN(childBirthDateRaw.getTime())) {
    createNotification({
      type: "error",
      message: "Tarehe ya kuzaliwa kwa mtoto haijapatikana au si sahihi.",
    })();
    return;
  }

  const parentBirthDate = normalizeDate(fixTimezoneOffset(parentBirthDateRaw));
  const childBirthDate = normalizeDate(fixTimezoneOffset(childBirthDateRaw));

  const minParentBirthDate = new Date(
    childBirthDate.getFullYear() - 14,
    childBirthDate.getMonth(),
    childBirthDate.getDate()
  );

  if (parentBirthDate > minParentBirthDate) {
    createNotification({
      type: "error",
      message: `Tarehe ya kuzaliwa kwa ${role} lazima iwe angalau miaka 14 kabla ya tarehe ya kuzaliwa kwa mtoto.`,
    })();

    setParentDOB(null);
    return;
  }

  setParentDOB(parentBirthDate);
};
//======================= End of new code =========================
 


  /**======================= old codes ========================================= */
  // const validateParentDOB = (dob, setParentDOB, role) => {
  //   if (!dob) return;

  //   // Normalize date to remove time zone effect
  //   const normalizeDate = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());

  //   const parentBirthDateRaw = new Date(dob);
  //   const parentBirthDate = normalizeDate(fixTimezoneOffset(parentBirthDateRaw));

  //   // Validate parent date
  //   if (isNaN(parentBirthDate.getTime())) {
  //     createNotification({
  //       type: "error",
  //       message: `Tafadhali weka tarehe sahihi kwa ajili ya ${role}.`,
  //     })();
  //     return;
  //   }

  //   // Get and normalize child birth date
  //   const childBirthDateRaw = new Date(getApplicantBirthDate());
  //   const childBirthDate = normalizeDate(childBirthDateRaw);

  //   if (isNaN(childBirthDate.getTime())) {
  //     createNotification({
  //       type: "error",
  //       message: "Tarehe ya kuzaliwa kwa mtoto haijapatikana au si sahihi.",
  //     })();
  //     return;
  //   }

  //   // Calculate minimum parent date (14 years older)
  //   const minParentBirthDate = new Date(
  //     childBirthDate.getFullYear() - 14,
  //     childBirthDate.getMonth(),
  //     childBirthDate.getDate()
  //   );

  //   if (parentBirthDate > minParentBirthDate) {
  //     createNotification({
  //       type: "error",
  //       message: `Tarehe ya kuzaliwa kwa ${role} lazima iwe angalau miaka 14 kabla ya tarehe ya kuzaliwa kwa mtoto.`,
  //     })();
  //     setParentDOB(null);
  //     return;
  //   }

  //   setParentDOB(parentBirthDate);
  // };
/**=========================End old codes ========================================= */


const handleSubmit = async (e) => {
    e.preventDefault();

    //refresh
    const Stage = stageID ?? 230;

    const formData = {
      ApplicationId: getAppId(),
      EmailAddress: getEmail(),
      Action: Stage == 230 ? "Insert" : "Update",
      FatherFullName,
      FatherDOB,
      FatherDistrictID: FatherDistrictID,
      FatherWard: FatherWardID,
      FatherVillage,
      MotherFullName,
      MotherDOB,
      MotherDistrictID,
      MotherWard: motherWardID,
      MotherVillage,
    };
    const navigateToStage = (stage, message) => {
      const routes = {
        230: "/stp3",
        240: "/stp4",
        250: "/stp5",
        260: "/stp6",
        270: "/stp6",
      };
      navigate(routes[stage] || "/continue");
      // createNotification({ type: "success", message })();
    };
    applicationManagementMasilingi(formData, "add-parents-info")
      .then((result) => {
        if (result.code == 1) {
          if (result.data) {
            const stID = result?.data[0]?.StageID
            setTStageID(stID)
          }
          if (Stage == 230 && formData.Action == "Insert") {
            navigate("/stp4");
          } else if (Stage == 240 && formData.Action == "Update") {
            navigate("/stp4");
          } else {
            navigateToStage(Stage, result.message);
          }
          setStageID(result?.data[0]?.StageID);
          createNotification({ type: "success", message: result.message })();
        } else if (
          result.code == 3 ||
          result.message.toLowerCase().includes("expire")
        ) {
          createNotification({ type: "error", message: "Session expired" })();
          navigate("/");
        } else {
          createNotification({ type: "error", message: result.message })();
        }
      })
      .catch(() => {
        createNotification({ type: "error", message: messages.networkError })();
      });
  };

  const endeleaBadae = () => {
    navigate("/");
  };

  //--------------------BackStage
  const handleBackStep = (endpoint, formData, routes) => {
    try {
      applicationManagementMasilingi(formData, endpoint).then((result) => {
        if (result.code == 1 && result.data.length > 0) {
          if (endpoint == "add_missing_personal_info") {
            set1BpersonalInfo(result?.data[0])
          } else if (endpoint == "add-address-info") {
            setAddressInfo(result.data[0])
          }
          const applicationFrom = result?.data[0]?.ApplicationFrom;
          const navigatePath = routes[applicationFrom] || routes.default;
          if (navigatePath) {
            navigate(navigatePath, { state: result?.data[0] });
          } else {
            const info = { type: "error", message: result.message };
            createNotification(info)();
          }
        } else if (result.code == 3) {
          sessionStorage.clear()
          localStorage.clear()
          navigate("/")
          const info = { type: "error", message: result.message };
          createNotification(info)();
        } else {
          const info = { type: "error", message: result.message };
          createNotification(info)();
        }
      });
    } catch (error) {
      const info = { type: "error", message: messages.networkError };
      createNotification(info)();
    }
  };

  const backStp1 = () => {
    const formData = {
      ApplicationId: getAppId(),
      EmailAddress: getEmail(),
      Action: "Select",
      BirthVillage,
      BirthWardID,
    };

    const routes = {
      3: "/stp1B",
      4: "/stp1",
      5: "/stp1",
      default: null,
    };

    handleBackStep("add_missing_personal_info", formData, routes);
  };

  const backStp2 = () => {
    const formData = {
      ApplicationId: getAppId(),
      EmailAddress: getEmail(),
      Action: "Select",
      HouseNumber: "",
      ResidenceDistrictID: "",
      ResidenceVillage: "",
    };

    const routes = {
      default: "/stp2",
    };

    handleBackStep("add-address-info", formData, routes);
  };

  return (
    <>
      <Header />
      <div className="container">
        <NavBar_appID />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12 module-content2">
            <div
              className="col-md-12 col-sm-12 col-xs-12 tab-registration-container"
              style={{ marginTop: "-5px" }}
            >
              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 tab-registration-menu hidden-xs">
                <div className="list-group">
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      backStp1();
                    }}
                    className="list-group-item done"
                  >
                    Habari Binafsi
                  </Link>
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      backStp2();
                    }}
                    className="list-group-item done"
                  >
                    Anuwani ya Makazi
                  </Link>
                  <Link to="#" className="list-group-item active">
                    Habari za Wazazi
                  </Link>
                  <Link className="list-group-item">Habari za Safari</Link>
                  <Link className="list-group-item">Wakati wa Dharura</Link>
                  <Link className="list-group-item">Viambatanisho</Link>
                  <Link className="list-group-item ">Tamko Rasmi </Link>
                  <Link className="list-group-item ">Malipo </Link>
                </div>
              </div>
              <div
                className="col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-registration-tab"
                style={{ marginTop: "1px", paddingRight: "1px" }}
              >
                <div className="tab-registration-content active">
                  <form id="step-three-form" onSubmit={handleSubmit}>
                    <div className="box box-default">
                      <div className="box-header with-border">
                        <h3 className="box-title">Habari za Baba</h3>
                      </div>
                      <div className="box-body">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">
                                Jina Kamili
                              </label>
                              <input
                                type="text"
                                id="FatherFullName"
                                className="form-control"
                                name="FatherFullName"
                                onChange={(e) => {
                                  const regex = /^[a-zA-Z '-]*$/;
                                  const value = e.target.value.toUpperCase();
                                  if (regex.test(value) || value === "") {
                                    setFatherFullName(value);
                                  }
                                }}
                                value={FatherFullName}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-4 required">
                            <label className="control-label">
                              Tarehe ya Kuzaliwa
                            </label>
                            <div className="row-fluid">
                              <DatePicker
                                id="DateofBirth"
                                onChange={(e) =>
                                  validateParentDOB(e, setFatherDOB, "Baba")
                                }
                                value={FatherDOB}
                                minDate={new Date(1900, 0, 1)}
                                maxDate={new Date()}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">Nchi</label>
                              <select
                                id="FatherCountries"
                                className="form-control"
                                name="FatherCountries"
                                value={FatherCountryID}
                                onChange={getFatherCountryIDChange}
                                required
                              >
                                <option value="">Chagua Nchi</option>
                                {FatherCountries.length > 0 &&
                                  FatherCountries?.map((country) => (
                                    <option
                                      key={country.id}
                                      value={country.ResourceID}
                                    >
                                      {country.ResourceName}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">Eneo</label>
                              <select
                                id="FatherTerritories"
                                className="form-control"
                                name="FatherTerritories"
                                value={fatherTerritoryID}
                                onChange={getFatherTerritoryIDChange}
                                required
                              >
                                <option value="">Chagua Eneo</option>
                                {FatherTerritories.length > 0 &&
                                  FatherTerritories?.map((territory) => (
                                    <option
                                      key={territory.id}
                                      value={territory.ResourceID}
                                    >
                                      {territory.ResourceName}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">Mkoa</label>
                              <select
                                id="FatherRegions"
                                className="form-control"
                                value={fatherRegionID}
                                onChange={getFatherRegionIDChange}
                                name="FatherRegions"
                                required
                              >
                                <option value="">Chagua Mkoa</option>
                                {FatherRegions.length > 0 &&
                                  FatherRegions?.map((region) => (
                                    <option
                                      key={region.ResourceID}
                                      value={region.ResourceID}
                                    >
                                      {region.ResourceName}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">Wilaya</label>
                              <select
                                id="FatherDistrictID"
                                className="form-control"
                                value={FatherDistrictID}
                                onChange={getFatherDistrictIDChange}
                                name="FatherDistrictID"
                                required
                              >
                                <option value="">Chagua Wilaya</option>
                                {FatherDistricts.length > 0 &&
                                  FatherDistricts?.map((district) => (
                                    <option
                                      key={district.ResourceID}
                                      value={district.ResourceID}
                                    >
                                      {district.ResourceName}
                                    </option>
                                  ))}{" "}
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">
                                Kata/Shehia
                              </label>
                              <select
                                id="FatherWard"
                                className="form-control"
                                value={FatherWardID}
                                onChange={getFatherBirthWardIDChange}
                                name="FatherWard"
                                required
                              >
                                <option value="">Chagua Kata/Shehia</option>
                                {FatherWards.length > 0 &&
                                  FatherWards?.map((ward) => (
                                    <option
                                      key={ward.ResourceID}
                                      value={ward.ResourceID}
                                    >
                                      {ward.ResourceName}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">
                                Mtaa/Kijiji
                              </label>
                              <input
                                type="text"
                                id="FatherVillage"
                                className="form-control"
                                name="FatherVillage"
                                onChange={(e) => {
                                  const regex = /^[a-zA-Z '-]*$/;
                                  const value = e.target.value.toUpperCase();
                                  if (regex.test(value) || value === "") {
                                    setFatherVillage(value);
                                  }
                                }}
                                value={FatherVillage}
                                required
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="box box-default">
                      <div className="box-header with-border">
                        <h3 className="box-title">Habari za Mama</h3>
                      </div>
                      <div className="box-body">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">
                                Jina Kamili
                              </label>
                              <input
                                type="text"
                                id="MotherFullName"
                                className="form-control"
                                name="MotherFullName"
                                onChange={(e) => {
                                  const regex = /^[a-zA-Z '-]*$/;
                                  const value = e.target.value.toUpperCase();
                                  if (regex.test(value) || value === "") {
                                    setMotherFullName(value);
                                  }
                                }}
                                value={MotherFullName}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-4 required">
                            <label className="control-label">
                              Tarehe ya Kuzaliwa
                            </label>
                            <div className="row-fluid">
                              <DatePicker
                                id="DateofBirth"
                                onChange={(e) =>
                                  validateParentDOB(e, setMotherDOB, "Mama")
                                }
                                value={MotherDOB}
                                minDate={new Date(1900, 0, 1)}
                                maxDate={new Date()}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">Nchi</label>
                              <select
                                id="MotherCountries"
                                className="form-control"
                                name="MotherCountries"
                                value={motherCountryID}
                                onChange={getMotherCountryIDChange}
                                required
                              >
                                <option value="">Chagua Nchi</option>
                                {MotherCountries.length > 0 &&
                                  MotherCountries?.map((country) => (
                                    <option
                                      key={country.id}
                                      value={country.ResourceID}
                                    >
                                      {country.ResourceName}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">Eneo</label>
                              <select
                                id="MotherTerritories"
                                className="form-control"
                                name="MotherTerritories"
                                value={motherTerritoryID}
                                onChange={getMotherTerritoryIDChange}
                                required
                              >
                                <option value="">Chagua Eneo</option>
                                {MotherTerritories.length > 0 &&
                                  MotherTerritories?.map((territory) => (
                                    <option
                                      key={territory.id}
                                      value={territory.ResourceID}
                                    >
                                      {territory.ResourceName}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">Mkoa</label>
                              <select
                                id="MotherRegions"
                                className="form-control"
                                value={motherRegionID}
                                onChange={getMotherRegionIDChange}
                                name="MotherRegions"
                                required
                              >
                                <option value="">Chagua Mkoa</option>
                                {MotherRegions.length > 0 &&
                                  MotherRegions?.map((region) => (
                                    <option
                                      key={region.ResourceID}
                                      value={region.ResourceID}
                                    >
                                      {region.ResourceName}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">Wilaya</label>
                              <select
                                id="MotherDistrictID"
                                className="form-control"
                                value={MotherDistrictID}
                                onChange={getMotherDistrictIDChange}
                                name="MotherDistrictID"
                                required
                              >
                                <option value="">Chagua Wilaya</option>
                                {MotherDistricts.length > 0 &&
                                  MotherDistricts?.map((district) => (
                                    <option
                                      key={district.ResourceID}
                                      value={district.ResourceID}
                                    >
                                      {district.ResourceName}
                                    </option>
                                  ))}{" "}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">
                                Kata/Shehia
                              </label>
                              <select
                                id="MotherWard"
                                className="form-control"
                                value={motherWardID}
                                onChange={getMotherBirthWardIDChange}
                                name="MotherWard"
                                required
                              >
                                <option value="">Chagua Kata/Shehia</option>
                                {MotherWards.length > 0 &&
                                  MotherWards?.map((ward) => (
                                    <option
                                      key={ward.ResourceID}
                                      value={ward.ResourceID}
                                    >
                                      {ward.ResourceName}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">
                                Mtaa/Kijiji
                              </label>
                              <input
                                type="text"
                                id="MotherVillage"
                                className="form-control"
                                name="MotherVillage"
                                onChange={(e) => {
                                  const regex = /^[a-zA-Z '-]*$/;
                                  const value = e.target.value.toUpperCase();
                                  if (regex.test(value) || value === "") {
                                    setMotherVillage(value);
                                  }
                                }}
                                value={MotherVillage}
                                required
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="box-footer">
                      <div className="row">
                        <div className="col-md-4">
                          <Link
                            onClick={(e) => {
                              e.preventDefault();
                              backStp2();
                            }}
                            className="btn btn-default btn-block btn-label-next"
                            name="SaveBack"
                          >
                            <i className="fa fa-angle-double-left"></i> | Hatua
                            Iliyotangulia
                          </Link>
                        </div>
                        <div className="col-md-4">
                          <Link
                            className="btn btn-labeled btn-block btn-default"
                            name="SaveExit"
                            onClick={(e) => {
                              e.preventDefault();
                              endeleaBadae();
                            }}
                          >
                            Hifadhi na Toka | <i className="fa fa-save"></i>{" "}
                          </Link>
                        </div>
                        <div className="col-md-4">
                          <button
                            className="btn btn-default btn-block btn-label-next"
                            name="SaveNext"
                          >
                            Hifadhi na Endelea |{" "}
                            <i className="fa fa-angle-double-right"></i>{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default Step_three;
